import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { DashboardItem } from '../../../shared/dto/dashboard/dashboard-item';

@Injectable({
	providedIn: 'root',
})
export class DashboardService {
	constructor(private http: HttpClient) {}

	getDashboard(day: string, country: string = 'BRA'): Observable<DashboardItem[]> {
		const params = new HttpParams()
			.set('day', day)
			// .set('day', '2024-04-16')
			.set('country', country);

		return this.http.get<DashboardItem[]>(
			`${environment.financialUrl}/dashboard`,
			{ params }
		).pipe(
			tap((response) => {
				console.log('[Dashboard] API response:', response);
			})
		);
	}
}
